export default function LogoTextWelScreen({ mobile }) {
  let icon = mobile ? (
    <svg
      width="150"
      height="11"
      viewBox="0 0 150 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.11573 9.11387L14.5558 0H16.2214L8.94345 10.2377H7.2981L0 0H1.66554L8.11573 9.11387Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9375 10.2384V0.0170898H19.3507V10.2466H17.9375V10.2384Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8007 1.72338V4.63555C34.8007 5.13595 34.5786 5.63635 34.1244 5.98089C33.7307 6.28441 33.2563 6.43207 32.7011 6.43207H30.7731L34.73 10.2466H32.8525L28.9158 6.43207H23.6163V10.2466H22.2031V0.0170898H32.6001C33.2159 0.0170898 33.8316 0.197563 34.2455 0.566711C34.6089 0.88664 34.8007 1.2722 34.8007 1.72338ZM24.2926 5.2672H32.691C32.8727 5.2672 33.0342 5.21798 33.1654 5.11134C33.2966 5.0047 33.3572 4.88165 33.3572 4.72579V1.72338C33.3572 1.57572 33.2966 1.44446 33.1654 1.32962C33.0342 1.22298 32.8828 1.16555 32.691 1.16555H24.2926C24.1109 1.16555 23.9494 1.22298 23.8081 1.32962C23.6769 1.43626 23.6062 1.56751 23.6062 1.72338V4.72579C23.6062 4.87344 23.6769 5.0047 23.8081 5.11134C23.9494 5.20978 24.1109 5.2672 24.2926 5.2672Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0156 0H48.6132V1.14846H43.0311V10.2377H41.6179V1.15667H36.0156V0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.5135 8.53144V0H62.9267V8.53144C62.9267 9.00723 62.7248 9.40919 62.3109 9.73732C61.9071 10.0737 61.4024 10.2377 60.8271 10.2377H52.4287C51.8432 10.2377 51.3486 10.0737 50.9448 9.73732C50.5411 9.40919 50.3291 8.99903 50.3291 8.53144V0H51.7423V8.53144C51.7423 8.6791 51.8129 8.81035 51.9442 8.9252C52.0754 9.03184 52.2369 9.08926 52.4287 9.08926H60.8271C61.0088 9.08926 61.1703 9.03184 61.3116 8.9252C61.4428 8.81855 61.5135 8.6873 61.5135 8.53144Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.3889 1.15667H66.3048V4.53643H73.5322V5.7013H66.3048V9.08926H76.3889V10.2377H64.8916V0H76.3889V1.15667Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.2812 0.0170898H91.2745C91.9811 0.0170898 92.5968 0.222172 93.1116 0.632338C93.6264 1.0425 93.8788 1.5429 93.8788 2.11714V4.7586C93.8788 5.34103 93.6264 5.83323 93.1116 6.2434C92.5968 6.65356 91.9811 6.85864 91.2745 6.85864L83.9966 6.87505C84.0269 6.87505 84.0471 6.89966 84.0471 6.95708C84.0269 6.95708 84.0067 6.94888 83.9966 6.94068V10.2302H81.2812V0.0170898ZM83.9966 2.22378V4.65196H91.1332V2.22378H83.9966Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.1264 0H105.546C106.252 0 106.868 0.205083 107.373 0.615248C107.877 1.02541 108.13 1.52581 108.13 2.10005V8.12947C108.13 8.71191 107.877 9.20411 107.373 9.61427C106.868 10.0244 106.252 10.2295 105.546 10.2295H98.1264C97.3997 10.2295 96.794 10.0244 96.2893 9.61427C95.7846 9.20411 95.5322 8.71191 95.5322 8.12127V2.09184C95.5322 1.5012 95.7846 1.00901 96.2893 0.598841C96.7839 0.205083 97.3997 0 98.1264 0ZM98.2476 2.66607V7.57985C98.2476 7.82595 98.4898 8.02283 98.7926 8.02283H104.839C105.142 8.02283 105.384 7.82595 105.384 7.57985V2.66607C105.384 2.41997 105.142 2.22309 104.839 2.22309H98.7926C98.4898 2.22309 98.2476 2.41997 98.2476 2.66607Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.423 5.11886L116.138 2.4856L118.692 0H122.306L117.026 5.11886L122.306 10.2213L118.692 10.2459L113.423 5.11886Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.804 6.22631V10.2377H110.078V0H112.804V5.38137V6.22631Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.25 0V2.21489H126.357V4.00321H132.636V6.2181H126.357V8.00642H135.25V10.2213H123.611V0H135.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.108 6.95708V10.2466H137.393V0.0170898H147.386C148.092 0.0170898 148.708 0.222172 149.223 0.632338C149.738 1.0425 149.99 1.5429 149.99 2.11714V4.7586C149.99 5.34103 149.738 5.83323 149.223 6.2434C148.708 6.65356 148.092 6.85864 147.386 6.85864H146.477L150 10.2302H146.407L142.924 6.85864L140.108 6.87505V6.95708ZM140.108 2.22378V4.65196H146.699C147.002 4.65196 147.245 4.45508 147.245 4.20898V2.66676C147.245 2.42066 147.002 2.22378 146.699 2.22378H140.108Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      width="293"
      height="20"
      viewBox="0 0 293 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8411 17.7893L28.4115 0H31.6624L17.4567 19.983H14.2451L0 0H3.25096L15.8411 17.7893Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0117 19.9842V0.0332031H37.7701V20.0002H35.0117V19.9842Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.927 3.3637V9.04796C67.927 10.0247 67.4935 11.0014 66.6069 11.6739C65.8385 12.2664 64.9125 12.5546 63.8288 12.5546H60.0656L67.7891 20.0002H64.1244L56.4403 12.5546H46.0963V20.0002H43.3379V0.0332031H63.6318C64.8337 0.0332031 66.0355 0.385467 66.8434 1.10601C67.5527 1.73047 67.927 2.48304 67.927 3.3637ZM47.4164 10.2809H63.8091C64.1638 10.2809 64.479 10.1848 64.7351 9.97665C64.9913 9.7685 65.1095 9.52832 65.1095 9.22409V3.3637C65.1095 3.07548 64.9913 2.81929 64.7351 2.59512C64.479 2.38697 64.1835 2.27488 63.8091 2.27488H47.4164C47.0617 2.27488 46.7465 2.38697 46.4706 2.59512C46.2145 2.80328 46.0766 3.05947 46.0766 3.3637V9.22409C46.0766 9.51231 46.2145 9.7685 46.4706 9.97665C46.7465 10.1688 47.0617 10.2809 47.4164 10.2809Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.2979 0H94.887V2.24168H83.9913V19.983H81.2329V2.25769H70.2979V0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.067 16.6525V0H122.825V16.6525C122.825 17.5812 122.431 18.3658 121.624 19.0062C120.835 19.6627 119.85 19.983 118.727 19.983H102.335C101.192 19.983 100.226 19.6627 99.4382 19.0062C98.6501 18.3658 98.2363 17.5652 98.2363 16.6525V0H100.995V16.6525C100.995 16.9407 101.133 17.1969 101.389 17.4211C101.645 17.6292 101.96 17.7413 102.335 17.7413H118.727C119.082 17.7413 119.397 17.6292 119.673 17.4211C119.929 17.2129 120.067 16.9567 120.067 16.6525Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.103 2.25769H129.42V8.85464H143.527V11.1283H129.42V17.7413H149.103V19.983H126.661V0H149.103V2.25769Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.652 0.0332031H178.158C179.537 0.0332031 180.739 0.433503 181.744 1.2341C182.749 2.0347 183.241 3.01144 183.241 4.13228V9.28814C183.241 10.425 182.749 11.3857 181.744 12.1863C180.739 12.9869 179.537 13.3872 178.158 13.3872L163.952 13.4192C164.011 13.4192 164.051 13.4673 164.051 13.5794C164.012 13.5794 163.972 13.5633 163.952 13.5473V19.9681H158.652V0.0332031ZM163.952 4.34043V9.07998H177.882V4.34043H163.952Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.533 0H206.015C207.394 0 208.596 0.4003 209.581 1.2009C210.566 2.0015 211.059 2.97823 211.059 4.09907V15.8679C211.059 17.0047 210.566 17.9655 209.581 18.7661C208.596 19.5667 207.394 19.967 206.015 19.967H191.533C190.115 19.967 188.933 19.5667 187.947 18.7661C186.962 17.9655 186.47 17.0047 186.47 15.8519V4.08306C186.47 2.9302 186.962 1.96948 187.947 1.16888C188.913 0.4003 190.115 0 191.533 0ZM191.77 5.2039V14.7951C191.77 15.2754 192.243 15.6597 192.834 15.6597H204.636C205.227 15.6597 205.7 15.2754 205.7 14.7951V5.2039C205.7 4.72354 205.227 4.33925 204.636 4.33925H192.834C192.243 4.33925 191.77 4.72354 191.77 5.2039Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.39 9.99149L226.69 4.85164L231.675 0H238.728L228.424 9.99149L238.728 19.951L231.675 19.999L221.39 9.99149Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.181 12.1531V19.983H214.861V0H220.181V10.5039V12.1531Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263.995 0V4.32324H246.637V7.81386H258.892V12.1371H246.637V15.6277H263.995V19.951H241.277V0H263.995Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.476 13.5794V20.0002H268.176V0.0332031H287.682C289.061 0.0332031 290.263 0.433503 291.267 1.2341C292.272 2.0347 292.765 3.01144 292.765 4.13227V9.28814C292.765 10.425 292.272 11.3857 291.267 12.1863C290.263 12.9869 289.061 13.3872 287.682 13.3872H285.908L292.785 19.9681H285.77L278.973 13.3872L273.476 13.4192V13.5794ZM273.476 4.34043V9.07998H286.342C286.933 9.07998 287.406 8.69569 287.406 8.21533V5.20508C287.406 4.72472 286.933 4.34043 286.342 4.34043H273.476Z"
        fill="white"
      />
    </svg>
  );
  return icon;
}
